export const formatTime = (timeString: string): string => {
  const date = new Date(timeString);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export const getProductLabel = (product: string): string => {
  const acronyms: Record<string, string> = {
    'aicoe': 'AICoE',
    'sts': 'STS',
    'ai': 'AI',
    'api': 'API',
    'rpa': 'RPA',
    'rbac': 'RBAC',
    'ui': 'UI'
  };

  return product
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => {
      const lowerWord = word.toLowerCase();
      return acronyms[lowerWord] || word.replace(/\b\w/g, c => c.toUpperCase());
    })
    .join(' ');
};
